// extracted by mini-css-extract-plugin
export default {"header":"blogs_header__zxkEs","home-head":"blogs_home-head__uO4Tm","blog-content":"blogs_blog-content__hcZCB","rto-image":"blogs_rto-image__kZGG8"};